import React, { useEffect, useMemo, useState, useRef } from "react";
import { apiFetch } from "../auth/authClient";
import { getToken } from "../auth/authClient";
import { useFormData } from "../context/FormDataContext";
import { apiJson } from "../auth/authClient";





// === POHREBKA: lastPrevoz helpers (AUTO) ===
function __pbSafeGetLS(key) {
  try { return (localStorage.getItem(key) || ""); } catch (e) { return ""; }
}
function __pbSafeSetLS(key, val) {
  try { localStorage.setItem(key, typeof val === "string" ? val : JSON.stringify(val)); } catch (e) {}
}
function __pbReadLastPrevozPatch() {
  try {
    const raw = __pbSafeGetLS("__POHREBKA_LAST_PREVOZ_PATCH");
    if (!raw) return null;
    const obj = JSON.parse(raw);
    return (obj && typeof obj === "object") ? obj : null;
  } catch (e) { return null; }
}
function __pbHasAnyPrevoz(patch) {
  if (!patch || typeof patch !== "object") return false;
  const p = patch.prevoz && typeof patch.prevoz === "object" ? patch.prevoz : null;
  const odkud = (p?.odkud ?? patch.prevoz_odkud ?? patch.prevozOdkud ?? "");
  const kam   = (p?.kam   ?? patch.prevoz_kam   ?? patch.prevozKam   ?? "");
  const datum = (p?.datum ?? patch.prevoz_datum ?? patch.prevozDatum ?? "");
  const km    = (p?.km    ?? patch.prevoz_km    ?? patch.prevozKm    ?? "");
  return Boolean(String(odkud).trim() || String(kam).trim() || String(datum).trim() || String(km).trim());
}
// === /POHREBKA ===


// === POHREBKA: SNAPSHOT HOTFIX HELPERS ===
function normStr(v) {
  if (v === null || v === undefined) return "";
  return String(v).trim();
}
function normNum(v) {
  if (v === null || v === undefined) return 0;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
}
function normArr(v) {
  if (Array.isArray(v)) return v.filter(Boolean).map(String);
  if (typeof v === "string") {
    const s = v.trim();
    if (!s) return [];
    return s.split(/[,;]+/).map(x => x.trim()).filter(Boolean);
  }
  return [];
}
function buildPrevozFromDraft(d) {
  const odkud = normStr(d?.odkud ?? d?.prevozOdkud ?? d?.prevoz_odkud);
  const kam = normStr(d?.kam ?? d?.prevozKam ?? d?.prevoz_kam);
  const datum = normStr(d?.datum ?? d?.prevozDatum ?? d?.prevoz_datum);
  const casOd = normStr(d?.casOd ?? d?.prevozCasOd ?? d?.prevoz_casOd);
  const autoSpz = normStr(d?.autoSpz ?? d?.prevozAutoSpz ?? d?.prevoz_autoSpz);
  const posadka = normArr(d?.posadka ?? d?.prevozPosadka ?? d?.prevoz_posadka);
  const km = normNum(d?.km ?? d?.prevozKm ?? d?.prevoz_km);

  const prevoz = { odkud, kam, datum, casOd, autoSpz, posadka, km };

  return {
    prevoz_odkud: odkud,
    prevoz_kam: kam,
    prevoz_datum: datum,
    prevoz_casOd: casOd,
    prevoz_autoSpz: autoSpz,
    prevoz_posadka: posadka,
    prevoz_km: String(km),

    prevozOdkud: odkud,
    prevozKam: kam,
    prevozDatum: datum,
    prevozCasOd: casOd,
    prevozAutoSpz: autoSpz,
    prevozPosadka: posadka,
    prevozKm: km,

    prevoz,
  };
}


// === AUTO: safeReadText (Response | object | string) ===
async function safeReadText(r) {
  try {
    if (!r) return "";
    if (typeof r === "string") return r;
    if (typeof r === "object" && typeof r.text === "function") return await r.text() ;
    if (typeof r === "object" && typeof r.json === "function") {
      const j = await r.json();
      return (typeof j === "string") ? j : JSON.stringify(j);
    }
    return (typeof r === "object") ? JSON.stringify(r) : String(r);
  } catch (e) {
    try { return String(e?.message || e); } catch (_) { return ""; }
  }
}
// === /AUTO ===

function getTokenSafe() {
  const t1 = (typeof getToken === "function" ? getToken() : "") || "";
  const t2 =
    (typeof window !== "undefined" && window.localStorage
      ? (getToken() ||
         getToken() ||
         getToken() ||
         getToken() ||
         "")
      : "") || "";
  return (t1 || t2 || "").trim();
}

/**
 * VÝJEZDY – modal krok 1
 * Účel: vybrat cílový výjezd + vybrat, co přesně nastavujeme (ODKUD / KAM / DATUM / ČAS / AUTO / POSÁDKA / KM).
 *
 * Použití:
 * <VyjezdyModalKrok1
 *   open={open}
 *   onClose={() => setOpen(false)}
 *   orderId={orderId}
 *   token={token}
 *   defaultStep={{ zdroj: "foto", gps: {lat, lng}, address, file, kategorie }}
 *   onDone={(result)=>{ ... }}
 * />
 */
export default function VyjezdyModalKrok1({
  open,
  onClose,
  orderId,
  token,
  defaultStep = null,
  onDone,
}) {
const { currentOrderId } = useFormData();
    const __lsGet = (k) => {
 try { return (localStorage.getItem(k) || ""); } catch { return ""; } };
  const effectiveOrderId = String(
    orderId ||
    currentOrderId ||
    __lsGet("currentOrderId") ||
    __lsGet("lastOpenedOrderId") ||
    ""
  ).trim();
const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [vyjezdy, setVyjezdy] = useState([]);

  const [mode, setMode] = useState("existing"); 
  const [advancedNew, setAdvancedNew] = useState(false);
// existing | new
  const [targetVyjezdId, setTargetVyjezdId] = useState("");
  const [field, setField] = useState("odkud"); // odkud | kam | datum | cas | autoSpz | posadka | km
  const [newDraft, setNewDraft] = useState({
    datum: "",
    casOd: "",
    casDo: "",
    autoSpz: "",
    posadkaText: "",
    km: "",
    odkud: "",
    kam: "",
    poznamka: "",
  });

  // === POHREBKA: SNAPSHOT HOTFIX draftRef (FIXED) ===
  const draftRef = useRef(null);
  useEffect(() => {
    try { draftRef.current = newDraft; } catch (e) {}
  }, [newDraft]);

// === AUTO FIX: define orderIdForStep2 BEFORE first useMemo ===
  // zdroje: effectiveOrderId / orderId / activeOrderId / vyjezd
    let orderIdForStep2 = String(
      (typeof effectiveOrderId !== "undefined" && effectiveOrderId) ||
      (typeof orderId !== "undefined" && orderId) ||
      (typeof activeOrderId !== "undefined" && activeOrderId) ||
      (typeof vyjezd !== "undefined" && vyjezd && (vyjezd.orderId || vyjezd.objednavkaId || vyjezd.idObjednavky)) ||
      ""
    ).trim();
  // === /AUTO FIX ===



  const canUse = useMemo(() => {
    if (!open) return false;
    if (!orderIdForStep2) return false;
      // token kontrolujeme až v handleContinue (getTokenSafe)
      // if (!token) return false;
    return true;
  }, [open, effectiveOrderId, token, mode, targetVyjezdId]);

  useEffect(() => {
    if (!open) return;
      if (!orderIdForStep2) return;
      setErr("");
    setLoading(true);

    const ac = new AbortController();

    apiFetch(`/api/vyjezdy/list?orderId=${encodeURIComponent(((typeof orderIdForStep2 !== "undefined" && orderIdForStep2) ? orderIdForStep2 : effectiveOrderId))}`, { method: "GET" })
      .then(async (r) => {
        const txt = await safeReadText(r) ;
        let j = null;
        try { j = JSON.parse(txt); } catch { /* ignore */ }
        if (!r.ok) throw new Error((j && (j.error || j.message)) || txt || `HTTP ${r.status}`);
        return j;
      })
      .then((j) => {
        const list = Array.isArray(j?.vyjezdy) ? j.vyjezdy : [];
        setVyjezdy(list);
          // === AUTO UX: když nejsou výjezdy, přepni na nový; když jsou, vyber první ===
          if (!list.length) {
            try { if (typeof setMode === "function") setMode("new"); } catch {}
            try { if (typeof setTargetVyjezdId === "function") setTargetVyjezdId(""); } catch {}
          } else {
            if (!targetVyjezdId && list.length) setTargetVyjezdId((Array.isArray(list) ? list[0] : list).id || "");
          }
          // === /AUTO UX ===
      })
      .catch((e) => {
        if (String(e?.name) === "AbortError") return;
        setErr(String(e?.message || e));
      })
      .finally(() => setLoading(false));

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, effectiveOrderId, token]);

  if (!open) return null;

  const overlayClose = (e) => {
    if (e?.target?.dataset?.overlay === "1") onClose?.();
  };

  async function createVyjezdIfNeeded() {
    if (mode !== "new") return targetVyjezdId;

    // vytvoříme nový výjezd přes existující create endpoint (pokud existuje), jinak použijeme update jako create
    // nejbezpečnější: POST /api/vyjezdy/create (pokud ho máš)
    const body = {
  orderId: (orderIdForStep2 || effectiveOrderId || orderId || ""),
      datum: newDraft.datum || "",
      casOd: newDraft.casOd || "",
      casDo: newDraft.casDo || "",
      autoSpz: newDraft.autoSpz || "",
      posadka: newDraft.posadkaText
        ? newDraft.posadkaText.split(",").map(s => s.trim()).filter(Boolean)
        : [],
      km: Number(newDraft.km || 0) || 0,
      odkud: newDraft.odkud || "",
      kam: newDraft.kam || "",
      poznamka: newDraft.poznamka || "",
    };

    const tryPaths = [
      { method: "POST", url: "/api/vyjezdy/create" },
      { method: "POST", url: "/api/vyjezdy/new" },
    ];

    let lastErr = null;
    for (const p of tryPaths) {
      try {
        
const j = await apiFetch(p.url, {
            method: p.method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          });

        const createdId =
          j?.vyjezd?.id ||
          j?.id ||
          j?.vyjezdId ||
          (Array.isArray(j?.vyjezdy) && j.vyjezdy[0]?.id) ||
          "";
        if (createdId) return createdId;

        // fallback: po vytvoření znovu načti list a vezmi poslední
        const rr = await apiFetch(`/api/vyjezdy/list?orderId=${encodeURIComponent(((typeof orderIdForStep2 !== "undefined" && orderIdForStep2) ? orderIdForStep2 : effectiveOrderId))}`, { method: "GET" });
        const t2 = await safeReadText(rr) ;
        let j2 = null;
        try { j2 = JSON.parse(t2); } catch { /* ignore */ }
        const list = Array.isArray(j2?.vyjezdy) ? j2.vyjezdy : [];
        const last = list[list.length - 1];
        if (last?.id) return last.id;

        return "";
      } catch (e) {
      try { console.error("🚑 handleContinue ERROR", e); alert("❌ handleContinue error: " + String(e?.message || e)); } catch (x) {}
lastErr = e;
      }
    }
    throw lastErr || new Error("create_failed");
  }

  async function handleContinue() {
  // === AUTO FIX: STEP2 requires orderId; try to resolve or create ===
  let _orderId = String(
    (typeof orderIdForStep2 !== "undefined" && orderIdForStep2) ||
    (typeof effectiveOrderId !== "undefined" && effectiveOrderId) ||
    (typeof orderId !== "undefined" && orderId) ||
    (typeof activeOrderId !== "undefined" && activeOrderId) ||
    (typeof currentOrderId !== "undefined" && currentOrderId) ||
    ""
  ).trim();

  // když není orderId, zkusíme vytvořit zakázku přes kontext (pokud existuje)
  if (!_orderId) {
    try {
      if (typeof createOrder === "function") {
        const created = await createOrder();
        // createOrder může vracet string nebo objekt { id }
        _orderId = String((created && (created.id || created.orderId)) || created || "").trim();
        if (_orderId && typeof setCurrentOrderId === "function") setCurrentOrderId(_orderId);
      }
    } catch (e) {
      console.warn("STEP2 createOrder failed:", e);
    }
  }

  if (!_orderId) {
    console.warn("⚠️ STEP2 aborted: Missing orderId");
    alert("❌ Chybí ID zakázky (orderId). Nejdřív založ/otevři zakázku a pak pokračuj.");
    return;
  }
  // === /AUTO FIX ===

  // === AUTOSELECT first vyjezd (existing mode) ===
  try {
    if (mode === "existing" && !targetVyjezdId && Array.isArray(vyjezdy) && vyjezdy.length) {
      const firstId = String((Array.isArray(vyjezdy) ? vyjezdy[0] : vyjezdy)?.id || "").trim();
      if (firstId) {
        console.warn("⚠️ AUTOSELECT first vyjezd → nastavím targetVyjezdId", { firstId });
        setTargetVyjezdId(firstId);
        // krátký tick aby se state propsal, ale pokračujeme i hned
      }
    }
  } catch (e) { /* ignore */ }


  const token = getTokenSafe();
  if (!token) {
    console.warn("❌ Nelze pokračovat: chybí token (přihlášení)", { effectiveOrderId: (orderIdForStep2 || effectiveOrderId) });
    alert("Vypršelo přihlášení. Prosím přihlas se znovu.");
    return;
  }


  // === DEBUG: reason when canUse is false ===
  if (!canUse) {
    const reasons = [];
    try {
      if (!orderIdForStep2) reasons.push("chybí orderId (ID zakázky)");
      if (!token) reasons.push("chybí token (přihlášení)");
      if (!field) reasons.push("není vybrané 'Co nastavujeme'");
    } catch (e) {}
    const msg = "❌ Nelze pokračovat: " + (reasons.length ? reasons.join(", ") : "canUse=false");
    try { console.warn(msg, { effectiveOrderId, token: token ? "[OK]" : "", field, mode, defaultStep }); } catch (e) {}
          // alert(msg) disabled (debug)
    try { setErr(msg); } catch (e) {}      try {
        console.warn("🧩 canUse=false dump", {
          canUse, loading,
          orderIdForStep2,
          effectiveOrderId,
          orderId,
          token: token ? "[OK]" : "",
          field,
          mode,
          defaultStep,
        });
      } catch (e) {}
      return;
  }
  // === /DEBUG ===

  // === DEBUG injected ===
  try {
    console.log("🚑 handleContinue START", { canUse, loading, field, defaultStep, effectiveOrderId });
  

    

  
      try {
        console.log("🧾 STEP2 IDs", { orderIdForStep2, effectiveOrderId });
      } catch (e) { console.warn("🧾 STEP2 IDs log failed", String(e?.message||e)); }
      console.log("🧾 STEP2 reached after IDs");
    // === STEP2: když nemáme orderId, vytvoř zakázku z výjezdu ===
    orderIdForStep2 = String(orderIdForStep2 || effectiveOrderId || (typeof orderId !== "undefined" ? orderId : "") || "").trim();
    // token ber z props nebo z authClient (LS na iPhonu bývá prázdné)
    const effectiveToken =
      (token && String(token).trim()) ||
      (typeof getToken === "function" ? String(getToken() || "").trim() : "");

    const doPostJson = async (url, bodyObj) => {
      // preferuj apiFetch pokud existuje (řeší base URL + auth + cookies)
      if (typeof apiFetch === "function") {
        return await apiFetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyObj || {}),
        });
      }
      // fallback: čistý fetch (zkusíme poslat bearer pokud token je)
      const headers = { "Content-Type": "application/json" };
      if (effectiveToken) headers["Authorization"] = `Bearer ${effectiveToken}`;
      const r = await fetch(url, {
        method: "POST",
        headers,
        credentials: "include",
        body: JSON.stringify(bodyObj || {}),
      });
      if (!r.ok) {
        const t = await r.text().catch(() => "");
        const err = new Error(`HTTP ${r.status} ${t}`.trim());
        err.status = r.status;
        throw err;
      }
      return await r.json();
    };

    if (!orderIdForStep2) {
      try {
        // payload je flexibilní – server si tahá klíče z vyjezd/vstupni/payload
        const payload = {
          zdroj: "vyjezd_modal",
          vyjezd: {
            ...newDraft,
            // přidej i info z defaultStep (z fotky/GPS), ať to má smysl v minimálce
            gps: defaultStep?.gps || null,
            address: defaultStep?.address || "",
            file: defaultStep?.file || "",
            kategorie: defaultStep?.kategorie || "",
          },
        };

        console.log("🧱 STEP2 create-from-vyjezd payload", payload);
const created = await apiJson("/api/zakazky/create-from-vyjezd", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});
console.log("🧱 STEP2 create-from-vyjezd response", created);
        const newId = String(
          created?.id || created?.orderId || created?.currentOrderId || created?.activeId || ""
        ).trim();

console.log("🧱 STEP2 newId =", newId);
if (!newId) { console.error("❌ STEP2 create-from-vyjezd: server returned no id", created); throw new Error("create-from-vyjezd returned no id"); }
          if (newId) {
            orderIdForStep2 = newId;
            try { localStorage.setItem("currentOrderId", newId); } catch {}
            try { localStorage.setItem("lastOpenedOrderId", newId); } catch {}
            try {
              const dbg = (typeof window !== "undefined" ? window.__POHREBKA_DEBUG_FORMDATA : null);
              if (dbg && typeof dbg.setCurrentOrderId === "function") dbg.setCurrentOrderId(String(newId));
              if (dbg && typeof dbg.updateFormData === "function") {
                dbg.updateFormData({
                  currentOrderId: String(newId),
                  orderId: String(newId),
                  zakazkaId: String(newId),
                  id: String(newId),
                  meta: {
                    id: String(newId),
                    orderId: String(newId),
                    zakazkaId: String(newId),
                  },
                });
              }
            } catch (e) {}
            console.log("✅ STEP2 auto-created orderId from vyjezd:", newId, created);
          } else {
          console.warn("⚠️ STEP2 create-from-vyjezd returned no id", created);
        }
      } catch (e) {
        console.warn("⚠️ STEP2 auto-create (create-from-vyjezd) failed", String(e?.message || e));
      }
    }
// AUTO: vždy používej efektivní orderId (props/context/LS fallback)
  const orderId = effectiveOrderId;
  if (!orderId) {
    setErr("Chybí ID zakázky (orderId). Otevři zakázku, nebo dej Nová zakázka, pak to zkus znovu.");
    console.warn("⚠️ STEP2: Missing orderId (effectiveOrderId empty)");
    return;
  }

    // === CANUSE_AUTOFIX_EXISTING ===
    // Pokud je mode=existing a není vybraný vyjezd, zkus vybrat první ze seznamu.
    // Když žádný není, přepni na mode=new a pokračuj.
    if (mode === "existing" && !String(targetVyjezdId || "").trim()) {
      const firstId = Array.isArray(vyjezdy) && vyjezdy.length ? ((Array.isArray(vyjezdy) ? vyjezdy[0] : vyjezdy)?.id || "") : "";
      if (firstId) {
        try { console.warn("⚠️ existing bez výběru → auto vyberu první vyjezd", { firstId }); } catch {}
        setTargetVyjezdId(String(firstId));
      } else {
        try { console.warn("⚠️ existing bez výjezdu → přepínám na new"); } catch {}
        setMode("new");
      }
    }

// === STEP2: backend propagate (vyjezd -> objednavka) ===
    try {
      const vyjezdId = (mode === "existing" ? String(targetVyjezdId || "").trim() : "");
      const draft = (mode === "new" ? (newDraft || {}) : null);

      async function postTry(url, body) {
  // apiJson vrací už rovnou JSON (a přidává auth)
  return await apiJson(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

      async function postAny(urls, body) {
        let lastErr = null;
        for (const u of urls) {
          try { return await postTry(u, body); }
          catch (e) { lastErr = e; }
        }
        throw lastErr || new Error("All endpoints failed");
      }

      // A) Získej detail vyjezdu (existing) nebo vytvoř nový (new)
      let savedVyjezd = null;
      if (mode === "existing") {
        if (!vyjezdId) throw new Error("missing vyjezdId (existing)");
        // nejdřív detail, když není, tak list+find
        savedVyjezd = await postAny(
          ["/api/objednavky/update","/api/objednavka/update","/api/zakazky/update","/api/order/update"],
          { effectiveOrderId, vyjezdId }
        ).catch(()=>null);

        if (!savedVyjezd) {
          const listRes = await postAny(
            ["/api/vyjezdy/list"],
            { effectiveOrderId: (orderIdForStep2 || effectiveOrderId) }
          ).catch(()=>null);
          const list = Array.isArray(listRes?.vyjezdy) ? listRes.vyjezdy : (Array.isArray(listRes) ? listRes : []);
          savedVyjezd = list.find(v => String(v?.id||"") === String(vyjezdId)) || null;
        }
      } else {
        const res = await postAny(
          ["/api/vyjezdy/add","/api/vyjezdy/create","/api/vyjezdy/save"],
          { effectiveOrderId: (orderIdForStep2 || effectiveOrderId), data: draft }
        );
        savedVyjezd = res?.vyjezd || res?.data || res;
      }

      // B) Patch do objednávky (Vstupní informace)
      const v = savedVyjezd || draft || newDraft || {};
      
        const patch = {
          // flat (legacy)
          prevoz_odkud: v.odkud || v.prevozOdkud || v.prevoz_odkud || "",
          prevoz_kam: v.kam || v.prevozKam || v.prevoz_kam || "",
          prevoz_datum: v.datum || v.prevozDatum || v.prevoz_datum || "",
          prevoz_casOd: v.casOd || v.cas || v.prevozCasOd || v.prevoz_casOd || "",
          prevoz_autoSpz: v.autoSpz || v.spz || v.prevozAutoSpz || v.prevoz_autoSpz || "",
          prevoz_posadka: v.posadkaText || v.posadka || v.prevozPosadka || v.prevoz_posadka || "",
          prevoz_km: (v.km !== undefined && v.km !== null) ? String(v.km) : (v.prevozKm ? String(v.prevozKm) : ""),

          // camelCase (časté v komponentách)
          prevozOdkud: v.odkud || v.prevozOdkud || v.prevoz_odkud || "",
          prevozKam: v.kam || v.prevozKam || v.prevoz_kam || "",
          prevozDatum: v.datum || v.prevozDatum || v.prevoz_datum || "",
          prevozCasOd: v.casOd || v.cas || v.prevozCasOd || v.prevoz_casOd || "",
          prevozAutoSpz: v.autoSpz || v.spz || v.prevozAutoSpz || v.prevoz_autoSpz || "",
          prevozPosadka: v.posadkaText || v.posadka || v.prevozPosadka || v.prevoz_posadka || "",
          prevozKm: (v.km !== undefined && v.km !== null) ? Number(v.km) : (v.prevozKm ? Number(v.prevozKm) : 0),

          // objekt (když máš formData.prevoz.*)
          prevoz: {
            odkud: v.odkud || v.prevozOdkud || v.prevoz_odkud || "",
            kam: v.kam || v.prevozKam || v.prevoz_kam || "",
            datum: v.datum || v.prevozDatum || v.prevoz_datum || "",
            casOd: v.casOd || v.cas || v.prevozCasOd || v.prevoz_casOd || "",
            autoSpz: v.autoSpz || v.spz || v.prevozAutoSpz || v.prevoz_autoSpz || "",
            posadka: v.posadkaText || v.posadka || v.prevozPosadka || v.prevoz_posadka || "",
            km: (v.km !== undefined && v.km !== null) ? Number(v.km) : (v.prevozKm ? Number(v.prevozKm) : 0),
          },
        };


      let patchedOrder = null;
      try {
        patchedOrder = await postAny(
          ["/api/objednavky/update", "/api/objednavka/update", "/api/order/update", "/api/zakazky/update"],
          { orderId: (orderIdForStep2 || effectiveOrderId || orderId || ""), effectiveOrderId: (orderIdForStep2 || effectiveOrderId), patch }
        );
      } catch (e) {
        console.warn("⚠️ STEP2 objednavka update failed", String(e?.message || e));
      }

      console.log("✅ STEP2 DONE", { savedVyjezd, patch, patchedOrder });

      try {
        if (typeof window !== "undefined" && window.dispatchEvent) {
          
      // === STEP2_PATCH_FILL_FROM_SAVEDVYJEZD ===
      // Když už máme savedVyjezd, doplníme patch i bez vyplnění modalu.
      // (a hlavně NEpřepisujeme prázdnem)
      const sv = (typeof savedVyjezd === "object" && savedVyjezd) ? savedVyjezd : {};
      const pick = (v) => (v === undefined || v === null) ? "" : String(v).trim();

      const vOdkud = pick(sv.odkud || sv.from || sv.odkudText);
      const vKam   = pick(sv.kam   || sv.to   || sv.kamText);
      const vDatum = pick(sv.datum || sv.date);
      const vCasOd = pick(sv.casOd || sv.timeFrom || sv.cas || sv.time);
      const vSpz   = pick(sv.autoSpz || sv.spz || sv.auto);
      const vPos   = pick(sv.posadkaText || sv.posadka || sv.osadka);
      const vKm    = pick(sv.km || sv.kilometry);

      const patchFilled = {
        ...(patch && typeof patch === "object" ? patch : {}),
        ...(vOdkud ? { prevoz_odkud: vOdkud, prevozOdkud: vOdkud } : {}),
        ...(vKam   ? { prevoz_kam:   vKam,   prevozKam:   vKam   } : {}),
        ...(vDatum ? { prevoz_datum: vDatum, prevozDatum: vDatum } : {}),
        ...(vCasOd ? { prevoz_casOd: vCasOd, prevozCasOd: vCasOd, prevoz_cas: vCasOd, prevozCas: vCasOd } : {}),
        ...(vSpz   ? { prevoz_autoSpz: vSpz, prevozAutoSpz: vSpz, prevoz_spz: vSpz, prevozSpz: vSpz } : {}),
        ...(vPos   ? { prevoz_posadka: vPos, prevozPosadka: vPos } : {}),
        ...(vKm    ? { prevoz_km: vKm, prevozKm: vKm } : {}),
        prevoz: {
          ...(patch && patch.prevoz && typeof patch.prevoz === "object" ? patch.prevoz : {}),
          ...(vOdkud ? { odkud: vOdkud } : {}),
          ...(vKam   ? { kam:   vKam   } : {}),
          ...(vDatum ? { datum: vDatum } : {}),
          ...(vCasOd ? { casOd: vCasOd } : {}),
          ...(vSpz   ? { autoSpz: vSpz } : {}),
          ...(vPos   ? { posadkaText: vPos } : {}),
          ...(vKm    ? { km: vKm } : {}),
        },
      };
      // === /STEP2_PATCH_FILL_FROM_SAVEDVYJEZD ===


      // === FORCE_PREVOZ_PATCH_FOR_UI ===
      // UI chce mít jistotu, že event vždy nese převoz v klíčích, které FormDataContext umí namapovat.
      try {
        const fillStr = (obj, key, val) => { try {
          const cur = obj && obj[key];
          const curS = (cur === undefined || cur === null) ? "" : String(cur);
          const vS = (val === undefined || val === null) ? "" : String(val);
          if (!curS.trim() && vS.trim()) obj[key] = vS;
        } catch (e) {} };
        const fillAny = (obj, key, val) => { try {
          const cur = obj && obj[key];
          if ((cur === undefined || cur === null || cur === "") && val !== undefined && val !== null && val !== "") obj[key] = val;
        } catch (e) {} };

                const _vy = (typeof savedVyjezd !== "undefined" && savedVyjezd) ? savedVyjezd : {};
        const _src = {
          ...(typeof newDraft === "object" && newDraft ? newDraft : {}),
          ...(typeof draft === "object" && draft ? draft : {}),
          ...(_vy && typeof _vy === "object" ? _vy : {}),
        };

        const _odkud = String(
          _src.odkud ?? _src.prevoz_odkud ?? _src.prevozOdkud ?? _src.from ?? _src.odkudText ?? ""
        ).trim();

        const _kam = String(
          _src.kam ?? _src.prevoz_kam ?? _src.prevozKam ?? _src.to ?? _src.kamText ?? ""
        ).trim();

        const _datum = String(
          _src.datum ?? _src.prevoz_datum ?? _src.prevozDatum ?? _src.date ?? ""
        ).trim();

        const _casOd = String(
          _src.casOd ?? _src.cas_od ?? _src.prevoz_casOd ?? _src.prevozCasOd ?? _src.prevoz_cas ?? _src.prevozCas ?? _src.cas ?? _src.timeFrom ?? _src.time ?? ""
        ).trim();

        const _autoSpz = String(
          _src.autoSpz ?? _src.auto_spz ?? _src.spz ?? _src.auto ?? _src.prevoz_autoSpz ?? _src.prevozAutoSpz ?? _src.prevoz_spz ?? _src.prevozSpz ?? ""
        ).trim();

        const _posadka = String(
          _src.posadkaText ?? _src.posadka ?? _src.osadka ?? _src.prevoz_posadka ?? _src.prevozPosadka ?? ""
        ).trim();

        const _km = String(
          _src.km ?? _src.kilometry ?? _src.prevoz_km ?? _src.prevozKm ?? ""
        ).trim();
if (typeof patchFilled === "object" && patchFilled) {
          fillStr(patchFilled, "prevoz_odkud", _odkud);
          fillStr(patchFilled, "prevoz_kam", _kam);
          fillStr(patchFilled, "prevoz_datum", _datum);
          fillStr(patchFilled, "prevoz_casOd", _casOd);
          fillStr(patchFilled, "prevoz_autoSpz", _autoSpz);
          fillStr(patchFilled, "prevoz_posadka", _posadka);
          fillStr(patchFilled, "prevoz_km", _km);

          patchFilled.prevoz = {
            ...(patchFilled.prevoz && typeof patchFilled.prevoz === "object" ? patchFilled.prevoz : {}),
            ...( _odkud ? { odkud: _odkud } : {} ),
            ...( _kam ? { kam: _kam } : {} ),
            ...( _datum ? { datum: _datum } : {} ),
            ...( _casOd ? { casOd: _casOd } : {} ),
            ...( _autoSpz ? { autoSpz: _autoSpz } : {} ),
            ...( _posadka ? { posadkaText: _posadka } : {} ),
            ...( _km !== "" ? { km: _km } : {} ),
          };
        }

        
        try {
          if (!patchFilled.prevoz || typeof patchFilled.prevoz !== "object") patchFilled.prevoz = {};
          fillStr(patchFilled.prevoz, "odkud", _odkud);
          fillStr(patchFilled.prevoz, "kam", _kam);
          fillStr(patchFilled.prevoz, "datum", _datum);
          fillStr(patchFilled.prevoz, "casOd", _casOd);
          fillStr(patchFilled.prevoz, "autoSpz", _autoSpz);
          fillStr(patchFilled.prevoz, "posadkaText", _posadka);
          fillAny(patchFilled.prevoz, "km", _km);
        } catch (e) {}
        console.log("🧲 FORCE_PREVOZ_PATCH_FOR_UI", { _odkud, _kam, _datum, _casOd, _autoSpz, _posadka, _km, hasPatch: !!(typeof patch === "object" && patch) });
      } catch (e) {
        console.warn("🧲 FORCE_PREVOZ_PATCH_FOR_UI failed", String(e?.message || e));
      }
      // === /FORCE_PREVOZ_PATCH_FOR_UI ===


      // === PATCH_TO_SEND (modal newDraft wins) ===
      // Když je režim NEW, ber hodnoty přímo z newDraft a pošli je do eventu (FormDataContext).
      // Tím obejdeme situaci, kdy backend vrátí jen {id} a pole jsou prázdná.
      const patchToSend = (() => {
    // === POHREBKA: SNAPSHOT HOTFIX inject (FIXED) ===
    const __snapFinal = (draftRef?.current ?? newDraft ?? {});
    const __patchFinal = buildPrevozFromDraft(__snapFinal);
    try {
      window.__POHREBKA_FORCE_LAST_PATCH = __patchFinal;
      window.__POHREBKA_PREVOZ_FROM_PATCH = __patchFinal.prevoz;
    } catch (e) {}

        try {
          const base = (typeof patchFilled === "object" && patchFilled) ? patchFilled : {};
          const nd = (typeof newDraft === "object" && newDraft) ? newDraft : null;
          const isNew = (typeof mode !== "undefined" && String(mode) === "new" && nd);

          if (!isNew) return base;

          const pick = (v) => (v === undefined || v === null) ? "" : String(v).trim();
          const odkud = pick(nd.odkud);
          const kam   = pick(nd.kam);
          const datum = pick(nd.datum);
          const casOd = pick(nd.casOd);
          const autoSpz = pick(nd.autoSpz);
          const posadka = pick(nd.posadkaText);
          const kmStr = pick(nd.km);

          
// === POHREBKA FORCE REAL SNAPSHOT ===
const snapReal = draftRef?.current ?? newDraft ?? draft ?? {};
const forcePatch = buildPrevozFromDraft(snapReal);
const out = { ...(base || {}) };

          // flat
          if (odkud) out.prevoz_odkud = odkud;
          if (kam)   out.prevoz_kam   = kam;
          if (datum) out.prevoz_datum = datum;
          if (casOd) out.prevoz_casOd = casOd;
          if (autoSpz) out.prevoz_autoSpz = autoSpz;
          if (posadka) out.prevoz_posadka = posadka;
          if (kmStr) out.prevoz_km = kmStr;

          // camel
          if (odkud) out.prevozOdkud = odkud;
          if (kam)   out.prevozKam   = kam;
          if (datum) out.prevozDatum = datum;
          if (casOd) out.prevozCasOd = casOd;
          if (autoSpz) out.prevozAutoSpz = autoSpz;
          if (posadka) out.prevozPosadka = posadka;
          if (kmStr) out.prevozKm = (kmStr ? (Number(kmStr) || 0) : (out.prevozKm ?? 0));

          // objekt prevoz
          const prev = (out.prevoz && typeof out.prevoz === "object") ? out.prevoz : {};
          out.prevoz = {
            ...prev,
            ...(odkud ? { odkud } : {}),
            ...(kam ? { kam } : {}),
            ...(datum ? { datum } : {}),
            ...(casOd ? { casOd } : {}),
            ...(autoSpz ? { autoSpz } : {}),
            ...(posadka ? { posadkaText: posadka } : {}),
            ...(kmStr ? { km: (parseFloat(kmStr) || 0) } : {}),
          };

          try { window.__POHREBKA_FORCE_LAST_PATCH = out; } catch (e) {}
          return out;
        } catch (e) {
          try { console.warn("patchToSend build failed", String(e?.message || e)); } catch (_) {}
          return (typeof patchFilled === "object" && patchFilled) ? patchFilled : {};
        }
      })();
      // === /PATCH_TO_SEND ===
window.dispatchEvent(

new CustomEvent("pohrebka:orderPatched", { detail: { orderId: (orderIdForStep2 || effectiveOrderId), effectiveOrderId: (orderIdForStep2 || effectiveOrderId), oid: (orderIdForStep2 || effectiveOrderId), patch: patchToSend, patchedOrder } }));
        }
      } catch (e) {}

      try { if (typeof onDone === "function") 
    // === POHREBKA: FORCE result.patch from snapshot (FIXED) ===
    try {
      if (typeof result === "object" && result) {
        result.patch = __patchFinal;

        
        
        // === POHREBKA: FORCE_FULL_PREVOZ_ON_CONTINUE ===
        // Odteď vždy posíláme CELÝ prevoz (žádný field-only patch).
        try {
          // zdroj 1: pokud uživatel něco vyplnil do newDraft, ber newDraft
          const srcDraft = (typeof newDraft !== "undefined" && __pbHasAnyDraft(newDraft)) ? newDraft : null;

          // zdroj 2: poslední uložený prevoz patch (LS) – když field-only generuje prázdno
          const lastPatch = __pbReadLastPrevozPatch();
          const srcLast = (lastPatch && (lastPatch.prevoz || lastPatch) && __pbHasAnyPrevoz(lastPatch)) ? (lastPatch.prevoz || lastPatch) : null;

          // zdroj 3: uložený výjezd ze serveru (savedVyjezd)
          const srcSaved = (typeof savedVyjezd !== "undefined" && savedVyjezd) ? savedVyjezd : null;

          // finální volba zdroje
          const src = (srcDraft || srcLast || srcSaved || {});

          let full = buildPrevozFromDraft(src);

          // když ani full nic nemá, ale existuje lastPatch, použij lastPatch přímo
          if (!__pbHasAnyPrevoz(full) && lastPatch && __pbHasAnyPrevoz(lastPatch)) {
            full = lastPatch;
          }

          // přepiš result.patch na full (ať se už nikdy neposílá prázdno)
          result.patch = full;

          // debug + persist
          try {
            window.__POHREBKA_FORCE_LAST_PATCH = full;
            window.__POHREBKA_PREVOZ_FROM_PATCH = full.prevoz || window.__POHREBKA_PREVOZ_FROM_PATCH;
          } catch (e) {}

          if (__pbHasAnyPrevoz(full)) {
            __pbSafeSetLS("__POHREBKA_LAST_PREVOZ_PATCH", full);
          }
        } catch (e) {}
        // === /POHREBKA ===
// === POHREBKA: fallback to last saved prevoz when current patch is empty ===
        try {
          const isOk = __pbHasAnyPrevoz(result.patch);
          if (!isOk) {
            const last = __pbReadLastPrevozPatch();
            if (last && __pbHasAnyPrevoz(last)) {
              result.patch = last;
              try { window.__POHREBKA_FORCE_LAST_PATCH = last; window.__POHREBKA_PREVOZ_FROM_PATCH = (last.prevoz || window.__POHREBKA_PREVOZ_FROM_PATCH); } catch (e) {}
            }
          } else {
            __pbSafeSetLS("__POHREBKA_LAST_PREVOZ_PATCH", result.patch);
          }
        } catch (e) {}
        // === /POHREBKA ===
if (result.savedVyjezd && typeof result.savedVyjezd === "object") {
          const pv = (__patchFinal && __patchFinal.prevoz) ? __patchFinal.prevoz : {};
          result.savedVyjezd = {
            ...result.savedVyjezd,
            datum: pv.datum ?? result.savedVyjezd.datum,
            casOd: pv.casOd ?? result.savedVyjezd.casOd,
            autoSpz: pv.autoSpz ?? result.savedVyjezd.autoSpz,
            odkud: pv.odkud ?? result.savedVyjezd.odkud,
            kam: pv.kam ?? result.savedVyjezd.kam,
            km: (pv.km ?? result.savedVyjezd.km),
            patch: __patchFinal,
          };
        }
      }
    } catch (e) {}
onDone({ savedVyjezd, patch, patchedOrder }); } catch {}
    } catch (e) {
      console.error("❌ STEP2 ERROR", e);
    }

} catch (e) {}
  try { alert("DEBUG: Klik na Pokračovat (krok 2) – start"); } catch (e) {}
  // === /DEBUG injected ===


    // === ONECLICK_EFFECTIVE_VYJEZD ===

    // Na první klik: když existing nemá vybraný vyjezd, vezmu první ze seznamu (lokálně) a pokračuju.

    let effectiveMode = mode;

    let effectiveVyjezdId = String(targetVyjezdId || "").trim();


    if (effectiveMode === "existing" && !effectiveVyjezdId) {

      const firstId = Array.isArray(vyjezdy) && vyjezdy.length ? String((Array.isArray(vyjezdy) ? vyjezdy[0] : vyjezdy)?.id || "").trim() : "";

      if (firstId) {

        effectiveVyjezdId = firstId;

        try { setTargetVyjezdId(firstId); } catch {}

        try { console.warn("⚠️ ONECLICK: existing bez výběru → beru první vyjezd", { firstId }); } catch {}

      } else {

        effectiveMode = "new";

        try { setMode("new"); } catch {}

        try { console.warn("⚠️ ONECLICK: žádný existující vyjezd → přepínám na new"); } catch {}

      }

    }


    const canUseNow =

      !!open && !!orderIdForStep2 && !!token && (effectiveMode === "existing" ? !!effectiveVyjezdId : true);


    if (!canUseNow) {

      try { console.warn("❌ ONECLICK: pořád nelze pokračovat", { open, orderId, token: token ? "[OK]" : "", effectiveMode, effectiveVyjezdId }); } catch {}

      return;

    }


    if (!canUse) return;

    setErr("");
    setLoading(true);

    try {
      const vyjezdId = await createVyjezdIfNeeded();
      if (!vyjezdId) throw new Error("nepodarilo se ziskat vyjezdId");

      // pouze vracíme volbu (krok 2 udělá samotné propsání)
      const result = {
  orderId,
        vyjezdId,
        field,
        defaultStep,
      };

      onDone?.(result);
      onClose?.();
    } catch (e) {
      setErr(String(e?.message || e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      data-overlay="1"
      onMouseDown={overlayClose}
      style={{ background: "rgba(0,0,0,0.55)" }}
    >
      <div
        className="w-[min(980px,95vw)] max-h-[90vh] overflow-auto rounded-2xl bg-white shadow-2xl p-4"
        data-overlay="0"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="text-lg font-semibold">🚑 Výjezdy – nastavení (krok 1)</div>
          <button
            className="px-3 py-1 rounded-xl border"
            onClick={onClose}
            type="button"
          >
            Zavřít
          </button>
        </div>

        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="rounded-2xl border p-3">
            <div className="font-semibold mb-2">1) Vyber výjezd</div>

            <div className="flex gap-2 mb-3">
              <button
                type="button"
                className={`px-3 py-1 rounded-xl border ${mode === "existing" ? "bg-gray-100" : ""}`}
                onClick={() => setMode("existing")}
              >
                Existující
              </button>
              <button
                type="button"
                className={`px-3 py-1 rounded-xl border ${mode === "new" ? "bg-gray-100" : ""}`}
                onClick={() => setMode("new")}
              >
                Nový
              </button>
            </div>

            
              {mode === "new" ? (
                <div className="mb-3">
                  <button
                    type="button"
                    className={`px-3 py-1 rounded-xl border ${advancedNew ? "bg-gray-100" : ""}`}
                    onClick={() => setAdvancedNew(v => !v)}
                    title="Detaily pro nový výjezd (pokud je potřebuješ)"
                  >
                    {advancedNew ? "Skrýt detaily" : "Zobrazit detaily"}
                  </button>
                  <div className="text-xs opacity-70 mt-1">
                    Doporučeno: datum/čas/odkud/kam vyplňuj nahoře ve Výjezdech. Modal je hlavně na výběr a pokračování.
                  </div>
                </div>
              ) : null}
              {mode === "existing" ? (
<>
                <div className="text-sm text-gray-600 mb-2">
                  Zakázka: <span className="font-mono">{effectiveOrderId || "—"}</span>
                </div>

                <select
                  className="w-full border rounded-xl p-2"
                  value={targetVyjezdId}
                  onChange={(e) => setTargetVyjezdId(e.target.value)}
                  disabled={loading}
                >
                  {vyjezdy.length ? (
                    vyjezdy.map((v) => (
                      <option key={v?.id || Math.random()} value={v?.id || ""}>
                        {(v?.datum || "—")} {(v?.casOd ? ` ${v.casOd}` : "")} {(v?.odkud ? ` | ${v.odkud}` : "")} {(v?.kam ? ` → ${v.kam}` : "")}
                      </option>
                    ))
                  ) : (
                    <option value="">(žádné výjezdy)</option>
                  )}
                </select>

                <div className="mt-2 text-xs text-gray-500">
                  Tip: když nevidíš žádné výjezdy, přepni na „Nový“ a vytvoř ho.
                </div>
              </>
              ) : (
                <>
                  {mode === "new" && advancedNew ? (
                    <div className="grid grid-cols-2 gap-2">
                <label className="text-sm">
                  Datum
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.datum}
                    onChange={(e) => setNewDraft((d) => ({ ...d, datum: e.target.value }))}
                    placeholder="YYYY-MM-DD"
                    disabled={loading}
                  />
                </label>
                <label className="text-sm">
                  Auto SPZ
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.autoSpz}
                    onChange={(e) => setNewDraft((d) => ({ ...d, autoSpz: e.target.value }))}
                    placeholder="např. 3C0 1234"
                    disabled={loading}
                  />
                </label>
                <label className="text-sm">
                  Čas od
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.casOd}
                    onChange={(e) => setNewDraft((d) => ({ ...d, casOd: e.target.value }))}
                    placeholder="HH:MM"
                    disabled={loading}
                  />
                </label>
                <label className="text-sm">
                  Čas do
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.casDo}
                    onChange={(e) => setNewDraft((d) => ({ ...d, casDo: e.target.value }))}
                    placeholder="HH:MM"
                    disabled={loading}
                  />
                </label>

                <label className="text-sm col-span-2">
                  Odkud
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.odkud}
                    onChange={(e) => setNewDraft((d) => ({ ...d, odkud: e.target.value }))}
                    placeholder="např. místo úmrtí / adresa"
                    disabled={loading}
                  />
                </label>
                <label className="text-sm col-span-2">
                  Kam
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.kam}
                    onChange={(e) => setNewDraft((d) => ({ ...d, kam: e.target.value }))}
                    placeholder="např. patologie / obřadní síň / hřbitov"
                    disabled={loading}
                  />
                </label>

                <label className="text-sm col-span-2">
                  Posádka (odděl čárkou)
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.posadkaText}
                    onChange={(e) => setNewDraft((d) => ({ ...d, posadkaText: e.target.value }))}
                    placeholder="např. Pavel, Petra"
                    disabled={loading}
                  />
                </label>

                <label className="text-sm">
                  Km
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.km}
                    onChange={(e) => setNewDraft((d) => ({ ...d, km: e.target.value }))}
                    placeholder="0"
                    disabled={loading}
                  />
                </label>
                <label className="text-sm col-span-1">
                  Poznámka
                  <input
                    className="mt-1 w-full border rounded-xl p-2"
                    value={newDraft.poznamka}
                    onChange={(e) => setNewDraft((d) => ({ ...d, poznamka: e.target.value }))}
                    placeholder="volitelné"
                    disabled={loading}
                  />
                </label>
              </div>
                  ) : (
                    <div className="text-sm text-gray-600">
                      Nový výjezd: detaily jsou schované. Pokud je chceš vyplnit tady v modalu, klikni „Zobrazit detaily“.
                    </div>
                  )}
                </>
              )}

          </div>

          <div className="rounded-2xl border p-3">
            <div className="font-semibold mb-2">2) Co nastavujeme</div>

            <div className="grid grid-cols-2 gap-2">
              {[
                ["odkud", "Odkud"],
                ["kam", "Kam"],
                ["datum", "Datum"],
                ["cas", "Čas (od/do)"],
                ["autoSpz", "Auto SPZ"],
                ["posadka", "Posádka"],
                ["km", "Km"],
              ].map(([v, label]) => (
                <button
                  key={v}
                  type="button"
                  className={`px-3 py-2 rounded-xl border text-left ${field === v ? "bg-gray-100" : ""}`}
                  onClick={() => setField(v)}
                  disabled={loading}
                >
                  {label}
                </button>
              ))}
            </div>

            <div className="mt-3 text-sm text-gray-600">
              Zdroj:{" "}
              <span className="font-mono">
                {defaultStep?.zdroj || "—"}
              </span>
            </div>

            {defaultStep?.address ? (
              <div className="mt-2 text-sm">
                Adresa: <span className="font-semibold">{defaultStep.address}</span>
              </div>
            ) : null}

            {defaultStep?.gps?.lat && defaultStep?.gps?.lng ? (
              <div className="mt-1 text-xs text-gray-500 font-mono">
                GPS: {defaultStep.gps.lat}, {defaultStep.gps.lng}
              </div>
            ) : null}

            <div className="mt-4 flex items-center gap-2">
              <button
                type="button"
                className="px-4 py-2 rounded-xl border bg-black text-white disabled:opacity-60"
                onClick={(e)=>{ try{console.log("✅ CLICK: Pokračovat (krok 2)");}catch{}; return handleContinue(e); }}
                disabled={false}
              >
                Pokračovat (krok 2)
              </button>
              {loading ? <div className="text-sm text-gray-500">Načítám…</div> : null}
            </div>

            {err ? (
              <div className="mt-3 text-sm text-red-600 whitespace-pre-wrap">{err}</div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
